module.exports = __webpack_public_path__ + "static/17 Live-ca955c82672240af39838ee1c3762b0b.svg";